import { GlobalVariable } from "app/global/global";
import { CentroMedicoService } from "app/services/centro-medico.service";
import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { PacienteService } from "app/services/paciente.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NotificationComponent } from "app/shared/notification/notification.component";
import { environment } from "environments/environment.prod";
import { SpinnerService } from "app/services/spinner.service";

import { TerminosYCondicionesDialogComponent } from "../../shared/terminos-ycondiciones-dialog/terminos-ycondiciones-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { TerminosYCondicionesService } from "../../services/terminos.service";
import { camposFaltantes } from "../../utils/form-errors.utils";

@Component({
  selector: "app-login-paciente",
  templateUrl: "./login-paciente.component.html",
  styleUrls: ["./login-paciente.component.scss"],
})
export class LoginPacienteComponent implements OnInit {
  //
  VERSION: string = GlobalVariable.VERSION_FRONT;
  titulo_login: string = "Mail";
  imagen: string = "";
  loginForm = new FormGroup({
    datoingreso: new FormControl("", Validators.required),
    password: new FormControl("", Validators.required),
  });
  hidePassword = true;

  //
  constructor(
    private router: Router,
    private pacienteService: PacienteService,
    private snackBar: MatSnackBar,
    private centroService: CentroMedicoService,
    private spinnerService: SpinnerService,
    private dialog: MatDialog,
    private terminosService: TerminosYCondicionesService
  ) {
    this.titulo_login =
      environment.PACIENTE_LOGIN == "MAIL" ? "Mail" : "Número documento";
    this.spinnerService.mostrarSpinner();
    this.centroService.getCentroImagen().subscribe(
      (data) => {
        this.imagen = `${GlobalVariable.BASE_API_URL}storage/images/centro-medico/${data}`;
        this.spinnerService.ocultarSpinner();
      },
      (error) => {
        this.spinnerService.ocultarSpinner();
      }
    );
  }

  //
  ngOnInit(): void {}

  //
  login(form) {
    if (this.loginForm.invalid) {
      this.openSnackBar(camposFaltantes(this.loginForm, { datoingreso: this.titulo_login, password: "Password" }), "error");
      return;
    }
    this.spinnerService.mostrarSpinner();
    this.pacienteService.login(form).subscribe({
      next: (data: any) => {
        if (!data.tc_valido) {
          this.spinnerService.ocultarSpinner();
          this.manejarTerminosYCondiciones(data);
        } else {
          this.pacienteService.handleData(data);
          this.openSnackBar("Ingreso exitoso", "exito");
          this.router.navigate(["/seccion-paciente/home-paciente/"]);
        }
      },
      error: (error) => {
        this.pacienteService.deleteDatosAutorizacion();
        this.spinnerService.ocultarSpinner();
        this.openSnackBar("Ingreso fallido: " + (error?.error?.error || ""), "error");
      },
    });
  }

  //
  openSnackBar(message: string, action: string) {
    this.snackBar.openFromComponent(NotificationComponent, {
      data: {
        message: message,
        action: action,
      },
      duration: 2500,
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: [action],
    });
  }

  private manejarTerminosYCondiciones(response: any) {
    const dialogRef = this.dialog.open(TerminosYCondicionesDialogComponent, {
      width: "600px",
      disableClose: true,
      data: {
        tc: response.tc,
        primeraVez: response.tc_primera_vez,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.aceptado) {
        this.aceptarTerminosYCompletar(response);
      } else {
        this.openSnackBar(
          "Debe aceptar los términos y condiciones para continuar",
          "error"
        );
      }
    });
  }

  private aceptarTerminosYCompletar(response: any) {
    this.spinnerService.mostrarSpinner();

    this.terminosService
      .aceptarTerminos({
        tipo_usuario: response.tc.tipo_usuario,
        id: response.paciente.id,
        tc_aceptado: response.tc.version,
      })

      .subscribe({
        next: () => {
          this.pacienteService.handleData(response);
          this.openSnackBar("Ingreso exitoso", "exito");
          this.router.navigate(["/seccion-paciente/home-paciente/"]);
        },
        error: () => {
          this.spinnerService.ocultarSpinner();
          this.openSnackBar(
            "Error al aceptar los términos y condiciones",
            "error"
          );
        },
      });
  }
}
